import { Theme } from '@pga/pga-component-library'
import { pathOr } from 'ramda'
import React from 'react'
import styled from 'styled-components'
import JobApplicationForm from './JobApplicationForm'
import { isInternshipApplicantGroup } from './utils'

export const JobApplySectionContainer = styled.div`
`
JobApplySectionContainer.displayName = 'JobApplySectionContainer'

export const Paragraph = styled.div`
  font-family: ${Theme.fonts.Montserrat};
  font-size: 14px;
  color: ${Theme.colors.blueGrey};
  text-align: justify;
  margin-bottom: 20px;
`

export const ApplyParagraph = styled(Paragraph)`
  color: ${Theme.colors.primary};
  a {
    color: ${Theme.colors.lightBlue};
  }
  margin-bottom: 40px;
`
ApplyParagraph.displayName = 'ApplyParagraph'

export const ApplyParagraphWrapper = ({ facilityUrl, data }) => {
  if (facilityUrl) {
    return (
      <ApplyParagraph>
        Click
        {' '}
        <a href={facilityUrl} target='_blank' rel='noopener noreferrer'>here to apply</a>
        {' '}
        for this job at company website
      </ApplyParagraph>
    )
  }
  if (isInternshipApplicantGroup(data)) {
    return (
      <ApplyParagraph>
        PGA Golf Management University Students: contact your Internship Coordinator if interested in this position.
      </ApplyParagraph>
    )
  }
}

const JobApplySection = ({ data, facilityUrl }) => (
  <JobApplySectionContainer id='application-form'>
    {
      facilityUrl || isInternshipApplicantGroup(data)
        ? <ApplyParagraphWrapper facilityUrl={facilityUrl} data={data} />
        : <JobApplicationForm job={pathOr({}, ['job'], data)} />
    }
  </JobApplySectionContainer>
)

export default JobApplySection
